'use client';

import { useStyle } from '@/classify';
import Icon from '@/components/Icon';
import clsx from 'clsx';
import { useCallback } from 'react';
import { Minus, Plus } from 'react-feather';
import { useAccordionContext } from './accordion';
import defaultClasses from './section.module.css';

const Section = props => {
  const { children, id, title, ...restProps } = props;

  delete restProps.isOpen;

  const { handleSectionToggle, openSectionIds } = useAccordionContext();

  const handleSectionToggleWithId = useCallback(() => handleSectionToggle(id), [handleSectionToggle, id]);

  const isOpen = openSectionIds.has(id);
  const titleIconSrc = isOpen ? Minus : Plus;
  const titleIcon = (
    <Icon
      classes={{
        root: clsx('text-80583F'),
      }}
      src={titleIconSrc}
      size={24}
    />
  );

  const classes = useStyle(defaultClasses, props.classes);
  const contentsContainerClass = isOpen ? classes.contents_container : classes.contents_container_closed;

  return (
    <div
      className={classes.root}
      {...restProps}
    >
      <button
        aria-expanded={isOpen}
        className={classes.title_container}
        onClick={handleSectionToggleWithId}
        type='button'
      >
        <span className={classes.title_wrapper}>
          <span className={classes.title}>{title}</span>
          {titleIcon}
        </span>
      </button>
      <div className={contentsContainerClass}>{children}</div>
    </div>
  );
};

export default Section;
